export const TEXT_TO_VOICE_LANGUAGES = [
  'bg',
  'zh-HK',
  'zh',
  'zh-TW',
  'cs',
  'da',
  'fi',
  'el',
  'hu',
  'id',
  'ko',
  'ms',
  'no',
  'pl',
  'ro',
  'sk',
  'sv',
  'tr',
  'uk',
  'vi',
  'nl',
  'en',
  'fr',
  'de',
  'hi',
  'it',
  'ja',
  'pt',
  'ru',
  'es',
];

export const TEXT_TO_VOICE_LANGUAGES_SET = new Set(TEXT_TO_VOICE_LANGUAGES);
